/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import axios from 'axios';
//import Modal from "react-responsive-modal";

import { toast } from 'react-toastify'; //토스트(toast)
// import { confirmAlert } from "react-confirm-alert"; //알럿창(alert confirm)
// import { AssignmentReturnedSharp } from "@material-ui/icons";

class PriceAgree1 extends Component {
  state = {
    agree: 'A',
  };

  _change = (e) => {
    this.setState({
      agree: e.target.value,
    });
  };
  _onAgree = async () => {
    const { agree } = this.state;
    const { history, setAgreeShow } = this.props;
    if (
      agree === 'A' ||
      agree === null ||
      agree === undefined ||
      agree === ''
    ) {
      toast.warn('변경 가격의 정기결제 동의, 비동의를 선택해 주세요.');
    } else {
      const result = await this._onAgreeApi();
      const intReturn = result.data[0].intReturn;

      if (intReturn === 0) {
        if (agree === 'Y') {
          toast.success('결제에 변경에 동의해 주셔서 대단히 감사드립니다.');
        } else {
          toast.success('정기결제가 정상 해지되었습니다. 감사합니다.');
        }
      } else if (intReturn === -2) {
        toast.error('정기결제가 존재하지 않습니다.');
      } else if (intReturn === -1) {
        toast.error('이미 동의/비동의 절차를 진행하셨습니다.');
      }

      history.goBack();
      setAgreeShow(false);
    }
  };
  _onAgreeApi = () => {
    const { apiUrl, loginId } = this.props;
    const { agree } = this.state;

    return axios
      .post(apiUrl + '/agreeOk', {
        params: {
          userid: loginId,
          agree: agree,
        },
      })
      .then((response) => response)
      .catch((error) => {
        alert('오류가 발생했습니다.');
      });
  };
  _CommaFormatted = (str) => {
    //console.log('aaaaaaaaaaaaaaaa')
    var Money;
    Money = '';
    while (parseInt(str) >= 1000) {
      if (parseInt(str) / 1000 > 0) {
        if (parseInt(str) % 1000 === 0) {
          Money = ',' + (parseInt(str) % 1000) + '00' + Money;
        } else {
          if (parseInt(str) % 1000 > 99)
            Money = ',' + (parseInt(str) % 1000) + Money;
          else if (parseInt(str) % 1000 > 9)
            Money = ',0' + (parseInt(str) % 1000) + Money;
          else Money = ',00' + (parseInt(str) % 1000) + Money;
        }
      }
      str = parseInt(str) / 1000;
    }
    Money = parseInt(str) + Money;

    return Money;
  };
  _onClose = () => {
    const { setAgreeShow } = this.props;
    setAgreeShow(false);
  };
  render() {
    const { agree } = this.state;
    const { infoData } = this.props.childProps;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="cashcard_pop" style={{ zIndex: 100 }}>
          <div className="cashcard_pop_layer4">
            <div className="cashcard_close2">
              <a
                style={{ cursor: 'pointer', zIndex: 1100 }}
                onClick={this._onClose}
              >
                닫기
              </a>
            </div>

            <div className="cashcard_pop_card">
              <h1>
                <img src={imgUrl + '/img/cashcard/logo_img.png'} />
                정기결제 가격 변경 동의
              </h1>

              <p style={{ lineHeight: 1.4, fontSize: 14 }}>
                {infoData[0].nicName} 회원님의 변경된 금액으로 다음 결제일은{' '}
                <span style={{ color: '#ff5d24', fontWeight: '800' }}>
                  {infoData[0].addPayDate}
                </span>{' '}
                입니다.
                <br />
                정기결제 가격 변경으로 인하여 아래와 같이 결제 동의를 얻고자
                합니다.
                {/*다음 결제일까지 변경된 가격으로 정기결제 됨에 동의하지 않으시면 정기결제가 자동 해지됩니다.*/}
              </p>
              <p style={{ paddingBottom: 10, fontSize: 14 }}>
                기존 결제금액:{' '}
                <span style={{ fontWeight: '800' }}>
                  {this._CommaFormatted(infoData[0].price)}
                </span>
                원 =&gt; 변경된 결제금액{' '}
                <span style={{ fontWeight: '800', color: '#ff5d24' }}>
                  12,900
                </span>
                원
              </p>

              <ul className="radius1">
                <li>
                  <div className="chek_group1">
                    <span
                      style={{
                        color: '#ff5d24',
                        fontSize: 11,
                        fontWeight: '800',
                      }}
                    >
                      변경된 금액으로 매월 정기결제 되는것에 동의 하시겠습니까?{' '}
                    </span>
                  </div>
                </li>
                <li>
                  <div className="chek_group1">
                    <input
                      name="vod"
                      id="checkbox_1"
                      type="checkbox"
                      value="Y"
                      checked={agree === 'Y' ? true : false}
                      className="checkbox_img"
                      onChange={this._change}
                    />
                    <label htmlFor="checkbox_1">예, 동의합니다.</label>
                    <span style={{ paddingLeft: 15 }}></span>
                    <input
                      name="vod"
                      id="checkbox_2"
                      type="checkbox"
                      value="N"
                      checked={agree === 'N' ? true : false}
                      className="checkbox_img"
                      onChange={this._change}
                    />
                    <label htmlFor="checkbox_2">
                      동의하지 않고 해지합니다.
                    </label>
                  </div>
                </li>
              </ul>

              <div className="cashcard_pop_line"></div>
              <p>
                동의하지 않을 경우 정기결제는 결제 만료일에 자동 해지 되며
                해지일로 부터 언제든 재가입이 가능합니다.
              </p>
              <p>정기결제 만료일까지 멤버십 서비스 이용에는 제한이 없습니다.</p>
              <p>
                본 화면은 정기결제 만료일 전까지 동의, 또는 비동의 의견을 제출
                하지 않을 시 로그인 후 반복하여 보여집니다.
              </p>
            </div>
            <a
              style={{ cursor: 'pointer' }}
              onClick={this._onAgree}
              className="btn_a"
            >
              확인
            </a>
            {/*<a style={{cursor: 'pointer'}} onClick={this._onSettingHide} className="btn_a" >취소</a>*/}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(PriceAgree1));
